import { Button } from '@/components/controls/Button'

export function FakeNav() {
  return (
    <div className="fake-nav">
      <div id="nav-primary" className="nav__wrapper">
        <nav>
          <ul className="nav nav--primary text-15-to-18">
            <li className="nav__item nav__item--primary">
              <span>Pricing</span>
            </li>
            <li className="nav__item nav__item--primary">
              <span>About</span>
            </li>
            <li className="nav__item nav__item--primary">
              <span>FAQ</span>
            </li>
            <li className="text-with-gradient">
              <ul className="flex">
                <li className="nav__item nav__item--primary">
                  <span>Blog</span>
                </li>
                <li className="nav__item nav__item--primary">
                  <span>Contact</span>
                </li>
                <li className="nav__item nav__item--primary">
                  <span>Login</span>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
        <Button href="#" type="primary">Join Now</Button>
      </div>
    </div>
  )
}
